import { FormEvent, useState } from 'react'
import { Container, Row, Col, Form, Button, FloatingLabel } from 'react-bootstrap'
import { LogoBig } from 'src/components/Icons'
import { EMAIL_VALIDATOR } from 'src/config/validators'
import Loader from 'src/components/Loader'
import Link from 'next/link'
import { resetPassword } from 'src/requests/auth'
import AlertMessage from 'src/components/AlertMessage'
import { IAlert } from 'src/interfaces/props'
import { useFormBackground } from 'src/helpers/hooks/auth'
import { withOutAuth } from 'src/helpers/hoc'
import Metadata from 'src/components/Metadata'

function ForgetPassword({}) {
  useFormBackground()
  const [email, setEmail] = useState('')
  const [mailSent, setMailSent] = useState(false)
  const [alert, setAlert] = useState<IAlert>()
  const [working, setWorking] = useState(false)

  const onReset = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!EMAIL_VALIDATOR.test(email)) return
    try {
      setWorking(true)
      await resetPassword(email)
      setMailSent(true)
      setWorking(false)
    } catch (error: any) {
      setWorking(false)
      console.log(error?.response?.data || error?.message)
      setAlert({
        text: error?.response?.data?.message || error?.message || 'Something went wrong',
        type: 'error',
      })
    }
  }

  return (
    <div className='forgetPassword'>
      <Metadata title='Reset User Password' />

      {working && <Loader />}

      {alert && <AlertMessage {...alert} />}

      <Container>
        <Row>
          <Col>
            <div className='form_login color_bg-white color_border-gray--08'>
              <div className='d-flex justify-content-center margin_bottom-24'>
                <LogoBig />
              </div>

              {!mailSent ? (
                <form onSubmit={onReset}>
                  <p className='text-center para-5 fw-400 color_text-gray--01' style={{ margin: '24px 0' }}>
                    Enter your email to reset password
                  </p>

                  <FloatingLabel controlId='floatingInput' label='Email Address' className='mb-3'>
                    <Form.Control type='email' placeholder='Email Address' className='form_input' value={email} onChange={({ target }) => setEmail(target.value)} required />
                  </FloatingLabel>

                  <Button variant='primary' type='submit' className='form_btn para-5 fw-300 w-100' disabled={!EMAIL_VALIDATOR.test(email)}>
                    Reset Password
                  </Button>

                  <p className='text-center' style={{ marginTop: '1em' }}>
                    <Link href='/login'>
                      <a
                        className='para-5 fw-300 color_text-primary
                    link_hover link_underline-none'
                      >
                        Cancel
                      </a>
                    </Link>
                  </p>
                </form>
              ) : (
                <div>
                  <p style={{ marginTop: '1em' }}>
                    if an account exists for <span className='fw-400 color_text-gray--01'>{email}</span>, you will get an email with instructions on resetting your password. If it doesn't arrive, be
                    sure to check your spam folder
                  </p>
                  <p className='fw-400 color_text-gray--01 text-center'>
                    <Link href='/login'>
                      <a className='form_btn-no-outline w-100'>Back to Login</a>
                    </Link>
                  </p>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default withOutAuth(ForgetPassword)
